import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const CriminalRecordDetails = () => <OperatorRequestDetails />;

export default CriminalRecordDetails;
